import { render, staticRenderFns } from "./dataCenterHigh.vue?vue&type=template&id=0958133b&scoped=true&"
import script from "./dataCenterHigh.vue?vue&type=script&lang=js&"
export * from "./dataCenterHigh.vue?vue&type=script&lang=js&"
import style0 from "./dataCenterHigh.vue?vue&type=style&index=0&id=0958133b&scoped=true&lang=css&"
import style1 from "./dataCenterHigh.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0958133b",
  null
  
)

export default component.exports